var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1066.37 179.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:gray;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1103.412,
    y1: 634.906,
    x2: 1098.816,
    y2: 841.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2586e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#1fdaf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    stopColor: "#1ed1f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bb4ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1438.29,662.845a19.768,19.768,0,0,0-13.16.7c-5.74,2.42-10.19,7.77-10.19,16.06s4.45,13.64,10.19,16.06a19.768,19.768,0,0,0,13.16.7c6.66-1.97,12.15-7.55,12.15-16.76S1444.95,664.815,1438.29,662.845Zm-20.64,50.54v122.05h30.08V713.385Z",
    transform: "translate(-808.16 -660.375)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M976.81,713.635l-27.86,91.47-26.63-91.47H895.94l-26.39,91.47-27.86-91.47H808.16l42.66,122.29h35.01l12.57-36,10.85-40.68,10.85,40.68,12.58,36h35.01l42.41-122.29Z",
    transform: "translate(-808.16 -660.375)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1143.73,746.915c15.04-4.68,23.92-20.46,23.92-34.02-.25-36.74-35.26-52.52-67.81-52.52-31.81,0-68.79,13.56-68.79,50.79h32.54c0-15.78,20.72-21.2,36-21.2,27.62,0,35.51,13.06,35.51,22.93-.25,16.02-18.74,20.71-36.25,20.71h-24.9v26.63h26.88c31.06,0,36.73,12.82,36.73,23.18,0,18.49-21.94,25.39-38.46,25.39-14.05,0-37.97-6.16-37.97-23.92h-32.79c.24,39.21,37.72,53.02,70.51,53.02,33.29,0,72.99-12.58,72.99-54.74C1171.84,768.615,1160.25,752.345,1143.73,746.915Z",
    transform: "translate(-808.16 -660.375)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1335.55,712.155c-15.78,0-29.83,4.93-40.68,22.19-6.91-16.77-21.45-22.69-36-22.69-11.59,0-25.64,4.44-32.06,16.77l-2.21-14.79h-27.87v121.8h30.08v-65.09c0-16.03,9.62-30.58,25.89-30.58,16.52,0,24.91,14.55,24.91,30.58v65.09h30.08v-65.09c0-16.03,10.11-30.08,26.38-30.08s22.93,13.56,22.93,29.58v65.59h30.08v-65.59C1387.08,733.355,1370.07,712.155,1335.55,712.155Z",
    transform: "translate(-808.16 -660.375)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1542.9,711.905c-15.28,0-27.61,6.17-39.94,18.25l-1.97-16.52h-26.88v121.8h29.84v-62.13c0-18.5,12.57-34.03,31.06-34.03,19.24,0,29.35,14.05,29.35,32.55v63.61h30.08v-63.86C1594.44,733.355,1571.51,711.905,1542.9,711.905Z",
    transform: "translate(-808.16 -660.375)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1716.48,663.085V730.4c-7.15-12.57-27.12-19.47-39.94-19.47-35.51,0-61.89,21.69-61.89,63.61,0,39.94,26.88,63.61,62.63,63.61,14.79,0,29.83-4.93,39.2-19.48l1.97,16.77h28.11V663.085Zm-37.23,147.2c-19.23,0-34.52-14.55-34.52-35.75,0-21.95,15.29-35.51,34.52-35.51,18.99,0,35.26,14.3,35.26,35.51C1714.51,796.475,1698.24,810.285,1679.25,810.285Z",
    transform: "translate(-808.16 -660.375)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1822.5,760.725c-15.53-.98-22.68-5.42-22.68-13.31,0-7.65,7.89-12.08,22.19-12.08,11.59,0,21.45,2.71,30.08,10.84l16.77-19.72c-14.06-12.33-28.36-16.03-47.35-16.03-22.19,0-51.28,9.86-51.28,37.97,0,27.62,27.37,36,50.3,37.73,17.26.98,24.16,4.44,24.16,12.82,0,8.88-10.6,14.79-21.94,14.55-13.56-.25-33.29-7.4-41.92-17.02l-14.79,21.45c17.75,18.5,36.98,21.7,56.21,21.7,34.77,0,52.28-18.49,52.28-39.94C1874.53,767.385,1845.43,762.205,1822.5,760.725Z",
    transform: "translate(-808.16 -660.375)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dacc1593ee5bdde39cf606af5ad98225.svg";
export { ForwardRef as ReactComponent };